<template>
  <CBox
    :bg="['none', 'var(--colors-light-primary-light-gray)']"
    :minHeight="['auto', 'calc(100vh - 80px)']"
    width="100vw"
    position="sticky"
    pt="10px"
  >
    <OmtGrid pt="40px">
      <OmtRow>
        <OmtTypography as="h1-bold" mb="40px"> Protocolo {{ protocol }} </OmtTypography>
      </OmtRow>
      <OmtRow>
        <div class="info-grid">
          <TextTile
            v-bind="{
              title: 'Assunto',
              description: detail.title
            }"
          />
          <TextTile
            v-bind="{
              title: 'Data da solicitação',
              description: detail.createdAt
            }"
          />
          <TextTile
            v-bind="{
              title: 'Beneficiário',
              description: detail.beneficiaryName
            }"
          />

          <TextTile
            v-if="(detail.statusCode == 'A' || detail.statusDsc == 'Em triagem') && !isMobile"
            v-bind="{
              title: 'Código do associado',
              description: detail.beneficiaryCode
            }"
          />

          <div>
            <OmtTypography as="p2" color="var(--colors-light-primary-gray2)"> Status </OmtTypography>
            <StatusTile v-chakra :label="detail.statusDsc" :color="statusColor" />
          </div>
        </div>
      </OmtRow>

      <OmtRow
        mt="32px"
        :desktopEnd="12"
        border="0.5px solid var(--colors-light-secondary-divider)"
        border-radius="8px"
        py="19px"
        px="16px"
        v-if="hasResponse"
      >
        <CBox>
          <CFlex>
            <OmtIcons name="memo" mr="16px" />
            <OmtTypography as="h2-bold"> {{ detail.doc.title }} </OmtTypography>
          </CFlex>
          <CFlex ps="27px" mb="16px">
            <OmtTypography as="p1">Data {{ detail.doc.createdAt }}</OmtTypography>
          </CFlex>
          <CFlex v-for="(r, index) in detail.doc.resp" :key="`resp-${index}`" ps="27px" mb="16px">
            <OmtTypography as="p1">{{ r.Resposta }}</OmtTypography>
          </CFlex>
          <CFlex v-if="hasDoc">
            <OmtButton w="100%" height="40px" fontSize="14px" @click="download"> Baixar </OmtButton>
          </CFlex>
        </CBox>
      </OmtRow>

      <template v-if="hasPendency">
        <OmtRow>
          <CDivider mt="16px" mb="16px" />
        </OmtRow>

        <OmtRow>
          <OmtTypography as="h2-bold" mb="24px"> Pendência(s) </OmtTypography>
        </OmtRow>

        <OmtRow mb="24px">
          <ul class="detail-request__reasons-list">
            <li v-for="(reason, index) in pendencyReasons" :key="`reason-${index}`">
              {{ reason }}
            </li>
          </ul>
        </OmtRow>
        <OmtRow>
          <CBox>
            <CFlex justify-content="center" mb="24px">
              <OmtButton w="343px" height="40px" fontSize="14px" @click="modalPendencies = true">
                Responder pendências
              </OmtButton>
            </CFlex>
            <div class="warning">
              <CFlex px="16px" pt="16px" pb="14px" align-items="center">
                <OmtIcons name="circle-exclamation" mr="14px" size="1x" />
                <OmtTypography as="h3-bold"> Atente-se ao prazo para regularização </OmtTypography>
              </CFlex>
              <CFlex ps="27px" mb="16px" px="16px" pb="16px">
                <OmtTypography as="p1">
                  As informações ou documentos solicitados
                  <omt-bold> devem ser enviados em até {{ detail.pendency.days }} dias,</omt-bold>
                  caso contrário, esta solicitação será cancelada.
                </OmtTypography>
              </CFlex>
            </div>
          </CBox>
        </OmtRow>
      </template>

      <template v-if="detail.description && !isInfoReceivedStatus">
        <OmtRow>
          <CDivider mt="32px" mb="32px" />
        </OmtRow>
        <OmtRow>
          <OmtTypography as="h2-bold" mb="16px"> Observações </OmtTypography>
        </OmtRow>

        <OmtRow>
          <OmtTypography as="p1" color="var(--colors-light-primary-gray2)">
            {{ detail.description }}
          </OmtTypography>
        </OmtRow>
      </template>

      <template v-if="detail.motivoEncerramento">
        <OmtRow>
          <CDivider mt="32px" mb="32px" />
        </OmtRow>
        <OmtRow>
          <OmtTypography as="h2-bold" mb="24px"> Resposta Omint </OmtTypography>
        </OmtRow>

        <OmtRow>
          <OmtTypography as="p1" color="var(--colors-light-primary-gray2)">
            {{ detail.motivoEncerramento }}
          </OmtTypography>
        </OmtRow>
      </template>

      <template v-if="detail.Pendencia && detail.Pendencia.observacao">
        <OmtRow>
          <CDivider mt="32px" mb="32px" />
        </OmtRow>
        <OmtRow>
          <OmtTypography as="h2-bold" mb="24px"> Retorno de pendência </OmtTypography>
        </OmtRow>

        <OmtRow>
          <OmtTypography as="p1" color="var(--colors-light-primary-gray2)">
            {{ detail.Pendencia.observacao }}
          </OmtTypography>
        </OmtRow>
      </template>

      <template v-if="pictures.length && !isInfoReceivedStatus">
        <OmtRow>
          <CDivider mt="32px" mb="32px" />
        </OmtRow>
        <OmtRow>
          <OmtTypography as="h2-bold" mb="24px"> Imagens enviadas </OmtTypography>
        </OmtRow>

        <OmtRow>
          <CGrid
            w="100%"
            :templateColumns="['repeat(auto-fill, minmax(74px, 1fr))', 'repeat(auto-fill, minmax(134px, 1fr))']"
            gap="6"
          >
            <ImagePreviewer
              v-for="(picture, index) in pictures"
              :key="index"
              v-bind="picture"
              :source="picture.source"
            />
          </CGrid>
        </OmtRow>
      </template>

      <PendingResponseModal
        :reasons="pendencyReasons"
        :pendencyObservation="pendencyObservation"
        :isOpen="modalPendencies"
        @close="closeModal"
        @submit="submit"
      />

      <SendPendency
        :daysAnalizy="daysAnalizy"
        :isOpen="openModalSuccess"
        :protocol="protocolANS"
        @close="closeModalSendPendency"
      />

      <Footer />
    </OmtGrid>
  </CBox>
</template>

<script>
import Footer from "@/components/Molecules/Footer";
import ImagePreviewer from "@/components/Molecules/ImagePreviewer";
import TextTile from "@/components/Molecules/TextTile";
import PendingResponseModal from "@/components/Organisms/Requests/PendingResponseModal.vue";
import SendPendency from "@/components/Organisms/Requests/SendPendency.vue";
import StatusTile from "@/components/Organisms/Requests/StatusTile.vue";
import { mapActions } from "vuex";
import { isMobile } from "@/utils/utils";

export default {
  name: "DetailRequest",
  components: {
    TextTile,
    StatusTile,
    Footer,
    PendingResponseModal,
    SendPendency,
    ImagePreviewer
  },
  data() {
    return {
      detail: {},
      modalPendencies: false,
      openModalSuccess: false,
      pictures: [],
      protocolANS: "",
      daysAnalizy: 3
    };
  },
  computed: {
    isInfoReceivedStatus() {
      return this.detail.statusDsc === "Informação recebida em análise";
    },
    protocol() {
      return this.$route.params.protocol ?? "";
    },
    statusColor() {
      switch (this.detail.statusCode) {
        case "F":
          return "var(--colors-light-support-success)";
        case "P":
          return "var(--colors-light-support-warning)";
        default:
          return "var(--colors-light-primary-dark-blue)";
      }
    },
    hasPendency() {
      return this.detail?.statusCode === "P" && this.detail?.pendency.ticket > 0;
    },
    hasDoc() {
      const idDoc = this.detail?.doc?.id ?? 0;
      return idDoc > 0;
    },
    hasResponse() {
      if (this.hasDoc) return true;
      const respostas = this.detail?.doc?.resp?.length ?? 0;
      return respostas > 0;
    },
    pendencyReasons() {
      if (!this.hasPendency) return [];
      return this.detail?.pendency?.reasons ?? [];
    },
    pendencyObservation() {
      if (!this.hasPendency) return "";
      return this.detail?.pendency?.observation ?? "";
    },
    isMobile() {
      return isMobile();
    }
  },
  methods: {
    ...mapActions("request", [
      "getDocumentUrl",
      "fetchProtocolDetail",
      "fetchProtocolDetailImage",
      "returnRequestTicket"
    ]),
    loadPictures() {
      if (!this.detail?.pictures?.length) return;
      this.detail.pictures.forEach(p =>
        this.fetchProtocolDetailImage({ documento: p, original: false }).then(source =>
          this.pictures.push({
            id: p,
            source: source,
            loadModalImage: () => this.loadPicture(p)
          })
        )
      );
    },
    async loadPicture(id) {
      return await this.fetchProtocolDetailImage({ documento: id, original: true });
    },
    async getDetail() {
      const detail = await this.fetchProtocolDetail({
        protocol: this.protocol
      });
      if (!detail) {
        this.$router.replace("/solicitacoes");
        return;
      }
      this.detail = detail;
      this.loadPictures();
    },
    async download() {
      const url = await this.getDocumentUrl({ protocol: this.protocol });
      window.open(url, "_blank");
    },
    closeModal() {
      this.modalPendencies = false;
    },
    async submit({ pictures, obs }) {
      if (!this.hasPendency) return;
      let response = {};
      try {
        await this.$root.$emit("show-loading");
        response = await this.returnRequestTicket({
          protocol: this.protocol,
          pictures,
          obs
        });
      } finally {
        await this.$root.$emit("hide-loading");
      }

      if (response && response.Data) {
        this.daysAnalizy = response.Data.prazos;
        this.protocolANS = response.Data.protocoloANS;
        this.modalPendencies = false;
        this.openModalSuccess = true;
        const detail = await this.fetchProtocolDetail({
          protocol: this.protocol
        });
        if (detail) {
          this.detail = detail;
        }
      } else {
        await this.$toast({
          description: "Não foi possivel registrar o atendimento.\nServiço temporariamente indisponível.",
          status: "error",
          duration: 10000,
          position: "top"
        });
      }
    },
    closeModalSendPendency() {
      this.openModalSuccess = false;
    }
  },
  async mounted() {
    try {
      this.$root.$emit("show-loading");
      await this.getDetail();
    } catch (error) {
      console.error(error);
    } finally {
      this.$root.$emit("hide-loading");
    }
  }
};
</script>

<style scoped>
.warning {
  background-color: #f6f6f9;
  border-radius: 8px;
}

.days-color {
  color: #c31700;
}

.detail-request__reasons-list {
  list-style-position: inside;
  color: var(--colors-light-primary-gray1);
  font-size: var(--fontSizes-sm);
  padding-left: var(--space-2);
}

.info-grid {
  display: grid;
  grid-template-columns: 1fr;
  row-gap: 16px;
}

@media (min-width: 768px) {
  .info-grid {
    grid-template-columns: repeat(2, 1fr);
    column-gap: 120px;
  }
}
</style>
